import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { AddIcon } from "shared/theme/icons/AddIcon";
import { useGameTagsData } from "../../stores/useGameTagsData";
import TagTypeItem from "./components/TagTypeItem";
import { StyledSection } from "./styled";

const Tags: FC = () => {
  const { gameTagTypeBlocks, addGameTagTypeBlock } = useGameTagsData();

  return (
    <>
      {gameTagTypeBlocks?.map((item, _index, items) => (
        <TagTypeItem
          key={item.id}
          id={item.id}
          primaryTagId={item.primaryTagId}
          selectedTags={item.selectedTags}
          deletable={items.length > 1}
        />
      ))}
      <ContentSection>
        <StyledSection onClick={addGameTagTypeBlock}>
          <AddIcon color={COLOR_PRIMARY_MAIN} />
          <Typography
            variant="bodyMMedium"
            color={COLOR_PRIMARY_MAIN}
            ml="0.5rem"
          >
            Add Filter
          </Typography>
        </StyledSection>
      </ContentSection>
    </>
  );
};

export default Tags;
